'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Information = void 0;
const $ = require("jquery");
class Information {
    constructor() {
        // Information切り替え
        $('.trigInformationSelect').on('click', (e) => {
            const category = $(e.currentTarget).attr('data-category');
            $('.bulletInformationSelect').hide();
            $(`.bulletInformationSelect[data-category="${category}"]`).show();
        });
    }
}
exports.Information = Information;
exports.default = Information;
